import Quill from 'quill';
window.Quill = Quill;